// Reine Helfer: 32-bit String-Hash + deterministischer Fisher-Yates-Shuffle (LCG-Seed).
// Speist die deterministische Szenario-Options-Reihenfolge.
export function strHash(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  return h;
}

export function seededShuffle(arr, seed) {
  const a = arr.slice();
  let s = seed | 0;
  for (let i = a.length - 1; i > 0; i--) {
    s = Math.imul(s, 1664525) + 1013904223 | 0;
    const j = (s >>> 0) % (i + 1);
    const tmp = a[i]; a[i] = a[j]; a[j] = tmp;
  }
  return a;
}
